'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconPlay = function IconPlay(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement('path', { d: 'm5 3.46590795v17.06575425c0 .3599895.35543404.584983.63978127.4049882l13.15105953-8.5328771c.2788789-.1799948.2788789-.6243568 0-.8043516l-13.15105953-8.53287715c-.28434723-.18561961-.63978127.03937386-.63978127.3993634z', fill: color })
  );
};

IconPlay.propTypes = {
  color: _propTypes2.default.string
};

IconPlay.defaultProps = {
  color: _colors2.default.icons
};

IconPlay.displayName = 'IconPlay';

exports.default = IconPlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/icons/icon-play.js
// module id = 815
// module chunks = 0